module.exports = __webpack_public_path__ + "static/img/img_kaifa1.bb509341.png";